module.exports = __webpack_public_path__ + "img/cristo_obrero.d6cd62b9.jpg";